import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { DeleteUser, UpdateUser } from "../types"

export const userMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateUser }) => {
			await tx.mutate.users.update({
				...args,
				id: args.id,
				updatedAt: Date.now(),
			})
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteUser }) => {
			// Hard delete
			await tx.mutate.users.delete({ id: args.id })
		},
	),
}
